<template>
  <div class="box" style="height:100%;">
    <div class="notice">
      <h1 class="title">
        <div style="cursor:pointer;text-align:center;font-weight: 600;color: rgba(255, 255, 255, 0.8);">
          <span>  公告阅读</span>
        </div>
      </h1>
      <div class="topone">
        <!-- <router-link :to="{name:'noticedetail', params:{articleId:oneItmes.id}}"> -->
        <p v-for="(noticeItem,index) in noticeList" :key="index" 
          style="padding:8px 17px;borderBottom:1px solid rgba(255,255,255,0.3);display:flex;flex-direction:column;just-content:flex-startcursor: pointer;" @click="goDetail(noticeItem.id)">
          <span class="time">{{ noticeItem.time }}</span>
          <span class="word">[公告]{{ noticeItem.title }}</span>
        </p>
        <!-- <div class="more">
          查看更多
        </div> -->
      </div>
      <div class="pageWrap">
        <el-pagination
          popper-class="_popStyle"
          :current-page="pageData.currentPage"
          :page-sizes="pageData.pageSizes"
          :page-size="pageData.pageSize"
          :pager-count="5"
          layout="prev, pager, next"
          :total="pageData.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <descDialog ref="descDialog" />
  </div>
</template>
<script>
/*global http protocol util */
import { mapGetters } from 'vuex'
import descDialog from '../../notice/tab/detailDialog.vue'
export default {
  name: 'NoticeCC',
  components: {
    descDialog
  },
  data() {
    return {
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 5,
        currentPage: 1
      },
      items: [],
      oneItmes: {},
      content: '',
      isNotice: true,
      abstract: [],
      noticeList: []
    }
  },
  computed: {
    // 商品策略
    ...mapGetters(['commodityStrategyGetter']),
    item() {
      const item = this.$store.state.hqData.item.symbolId
      if (item) {
        return this.$store.state.hqData.item.symbolId
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbolId
        } else {
          return '--'
        }
      }
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    protocol.param_noticeList.param.articleTitle = ''
  },
  methods: {
    goDetail(id) {
      this.$refs.descDialog.showDialog(id)
    },
    init() {
      this.getArticle()
    },
    getArticle() {
      this.noticeList = []
      protocol.param_noticeList.param.page = this.pageData.currentPage - 1
      protocol.param_noticeList.param.size = this.pageData.pageSize
      http.getRes(protocol.param_noticeList).then((response) => {
        const { content, totalElements } = response.data.value
        this.pageData.total = Number(totalElements)
        if (content) {
          for (const value of content) {
            const obj = value
            obj.time = util.dateDayFormate(
              Number(value.createTime)
            )
            this.noticeList.push(obj)
          }
        }
      })
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.getArticle()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.getArticle()
    },
    goNotice() {
      window.sessionStorage.setItem('selectnPage', 2)
      this.$router.push('/notice'
      )
    },
    goWhitePage() {
      window.sessionStorage.setItem('selectnPage', 1)
      this.$router.push('/notice'
      )
    }
  }
}
</script>
<style scoped lang="scss">
.box {
  width: 100%;
  overflow: hidden;
  .notice {
    height: 100%;
    position: relative;
    .title {
      margin-bottom: 10px;
      height: 43px;
      font-size: 14px;
      line-height: 35px;
      // background:#111217;
      text-indent:20px;
      font-weight: normal;
      border-bottom: 1px solid rgba($color: #ffffff, $alpha: 0.3);
      /* border-bottom: 1px solid rgba(78, 89, 133, 1); */
    }
    .topone{
      // padding: 0 20px;
      padding: 0 8px;
      // height: calc(100% - 64px);
      height: 300px;
      overflow-y:auto;
      position: relative;
      a{
        display: flex;
        justify-content: space-between;
      }
        .more{
          position: absolute;
          right:20px;
          bottom:20px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #0486FE;
        }
      .word{
        // line-height: 35px;
        overflow: hidden;
        max-width: 68%;
        text-overflow:ellipsis;
        white-space: nowrap;
        -webkit-line-clamp: 1;
        font-family: Source Han Sans SC;
        font-weight: 500;
        font-size: 14px;
        color: #DFDFDF;

      }
      .time {
        // line-height: 35px;
        font-family: Source Han Sans SC;
        font-weight: 200;
        font-size: 12px;
        color: #989898;
        margin-bottom: 8px;
      }
    }
    .top {
      height: 35px;
      padding: 0 20px;
      border-bottom: 1px solid rgba(78, 89, 133, 1);
      .word {
        width:50%;
        line-height: 35px;
        font-size: 14px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        -webkit-line-clamp: 1;
        color: #61688a;
        float: left;
      }
      .time {
        line-height: 35px;
        font-size: 12px;
        color: rgba(78, 89, 133, 1);
      
        width:50%;
        
      }
    }
  }
  .pageWrap {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    margin-top: 2px;
    padding: 0 20px;
    /deep/ .el-pagination {
      button:disabled, .btn-prev, .btn-next, .el-pager li {
        background-color: transparent;
      }
      button:disabled, button, button:disabled:hover {
        color: #979797;
      }
      button:hover {
        color: #ffffff;
      }
      .el-pager {
        // display: flex;
        // justify-content: center
        li {
          font-family: Source Han Sans SC;
          font-weight: 400;
          font-size: 12px;
          color: #E8E8E8;
        }
        .active {
          // background: #E8E8E8;
          // color: #121212;
          font-weight: bold;
        }
      }
    }
  }
  // .pageWrap{
  //   padding: 0 10px;
  //   box-sizing: border-box;
  //   overflow: hidden;
  //   // padding-top: 67px;
  //   height: calc(100% - 393px);
  //   width: 100%;
  //   // background-color:#141517;
  //   position: absolute;
  //   bottom: 5px;
  //   text-align: center;
  //   /deep/ .el-pagination button:disabled,/deep/ .el-pagination button {
  //     color: #979797;
  //   }
  //   /deep/ .el-pagination button:hover {
  //     color: #ffffff;
  //   }
  //   /deep/ .el-pagination button:disabled:hover {
  //     color: #979797;
  //   }
  //   /deep/ .el-pagination button:disabled,/deep/ .el-pagination .btn-prev,/deep/ .el-pagination .btn-next,/deep/ .el-pager li,/deep/ .el-pagination__editor.el-input .el-input__inner{
  //     background-color: transparent;
  //   }
  //   /deep/ .el-pagination .el-select .el-input .el-input__inner{
  //     background-color: transparent;
  //     border-color: rgba(255, 255, 255, 0.6);
  //   }
  //   /deep/ .el-input__inner{
  //     border-color: rgba(255, 255, 255, 0.6);
  //   }
  //   /deep/.el-pagination__jump{
  //       margin-left:0;
  //   }
  // }
}
</style>
